module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_recruitment_text_sm-b5499956364d1fc84d0316703cc1b484.svg";